import {
  _primaryControls,
  _increment,
  code,
  name,
  amount,
  type,
  customer_id,
  quotation,
  status,
  totalExpenses,
  targetDateWarning,
  bom_stats,
  created_at,
  target_date,
} from './base';

export default {
  types: {
    _primaryControls,
    _increment,
    code,
    name,
    amount,
    type,
    customer_id,
    quotation,
    status,
    targetDateWarning,
    bom_stats,
    totalExpenses,
    created_at,
    target_date,
  },

  sortable: [
    'code',
    'name',
    'status',
    'created_at',
    'target_date',
  ],
};
